import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../constants/common'
import { FormikField } from '../../Formik'
import { NotificationInline } from '../../Notification'
import {
  SettingsFormSection,
  SettingsSwitch,
  SettingsSwitchField,
} from '../../Settings'
import {
  CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS,
  CALENDAR_SETTINGS_SWITCH_LABEL_KEYS,
  CALENDAR_SETTINGS_TASK_TYPES_SECTION_DESCRIPTION_KEY,
  CALENDAR_SETTINGS_TASK_TYPES_SECTION_TITLE_KEY,
  QA_NAME_CALENDAR_SETTINGS_NO_TIMEZONE,
  QA_NAME_CALENDAR_SETTINGS_TASK_TYPES,
} from '../CalendarSettings.constants'
import { useCalendarSettingsSubmit } from '../CalendarSettings.hooks'
import { getCalendarSettingsInitialValues } from '../CalendarSettings.utils'

import { DueDatesSection } from './DueDatesSection'
import { TaskTypesField } from './TaskTypesField'

import * as styles from './CalendarSettingsForm.module.css'

function CalendarSettingsForm({ settings, onSave }) {
  const { t } = useTranslation()

  const { handleSubmit } = useCalendarSettingsSubmit({ settings, onSave })

  return (
    <div className={styles.CalendarSettingsForm}>
      <SettingsFormSection
        after={<DueDatesSection />}
        descriptionKey={CALENDAR_SETTINGS_TASK_TYPES_SECTION_DESCRIPTION_KEY}
        initialValues={getCalendarSettingsInitialValues(settings)}
        qaName={QA_NAME_CALENDAR_SETTINGS_TASK_TYPES}
        titleKey={CALENDAR_SETTINGS_TASK_TYPES_SECTION_TITLE_KEY}
        onSubmit={handleSubmit}
      >
        {settings.timezone ? null : (
          <NotificationInline
            qaName={QA_NAME_CALENDAR_SETTINGS_NO_TIMEZONE}
            text={t('CalendarSettings.NoTimezoneKey')}
            type={NOTIFICATION_TYPE.warning}
          />
        )}
        <TaskTypesField taskTypes={settings.task_types} />
        <FormikField
          Component={SettingsSwitch}
          Field={SettingsSwitchField}
          fieldComponentProps={{
            label: t('CalendarSettings.ShowProviderTasksKey'),
          }}
          labelKeys={CALENDAR_SETTINGS_SWITCH_LABEL_KEYS}
          name={CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS}
        />
      </SettingsFormSection>
    </div>
  )
}

export default CalendarSettingsForm
